<template>
    <v-data-table
        class="elevation-2 mt-5"
        :options.sync="tableOptions"
        :page.sync="page"
        :headers="headers"
        :items="users"
        :items-per-page="10"
        :footer-props="{
            itemsPerPageOptions: [10, 25, 50]
        }"
        :server-items-length="count"
    >
        <template v-slot:top>
            <v-row>
                <v-col cols="12" md="7">
                    <v-btn
                        v-if="visibilityConfig.refresh"
                        class="ma-2"
                        icon
                        medium
                        @click="$emit('refresh')"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
                <v-col v-if="visibilityConfig.search" cols="12" md="5">
                    <v-text-field
                        v-model="search"
                        class="mx-5 pt-1 data-table-search"
                        :label="$t('formCommon.searchByEverything')"
                        clearable
                    />
                </v-col>
            </v-row>
        </template>
        <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | dateTimeFormatFromSettings }}
        </template>
        <template v-slot:item.action="{ item }">
            <div class="d-flex">
                <v-icon
                    v-if="visibilityConfig.actions.edit"
                    class="mr-3"
                    size="20"
                    @click="$emit('edit', item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.delete"
                    size="20"
                    class="mr-3"
                    @click="$emit('delete', item)"
                >
                    mdi-delete
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.showHistory"
                    size="20"
                    class="mr-3"
                    @click="$emit('showHistory', item)"
                >
                    mdi-history
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.restore"
                    size="20"
                    class="mr-3"
                    @click="$emit('restore', item)"
                >
                    mdi-undo
                </v-icon>
            </div>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: 'employeeList',

    props: {
        visibilityConfig: {
            type: Object,
            required: false,
            default: () => ({
                actions: {
                    edit: true,
                    delete: true,
                    showHistory: true,
                    restore: false
                },
                search: true,
                refresh: true,
                excludeHeaders: null
            })
        },
        users: {
            type: Array,
            required: true
        },
        count: {
            type: Number,
            required: false,
            default: 0
        },
        page: {
            type: Number,
            required: false,
            default: 1
        }
    },

    data() {
        return {
            headers: [
                {
                    text: this.$t('employeesView.headers.firstName'),
                    value: 'firstName'
                },
                {
                    text: this.$t('employeesView.headers.lastName'),
                    value: 'lastName'
                },
                {
                    text: this.$t('employeesView.headers.phone'),
                    value: 'phone'
                },
                {
                    text: this.$t('employeesView.headers.email'),
                    value: 'email'
                },
                {
                    text: this.$t('employeesView.headers.numberOfVacationDays'),
                    value: 'numberOfVacationDays',
                    sortable: false
                },
                {
                    text: 'Months of experience',
                    value: 'experience'
                },
                {
                    text: this.$t('employeesView.headers.createdAt'),
                    value: 'createdAt'
                },
                {
                    text: this.$t('employeesView.headers.actions'),
                    value: 'action',
                    sortable: false
                }
            ],
            search: '',
            tableOptions: {}
        };
    },

    watch: {
        tableOptions: {
            handler(options) {
                this.$emit('updateTable', options);
            },
            deep: true
        },
        search(query) {
            this.$emit('updateTable', { ...this.tableOptions, query });
        }
    }
};
</script>
